
export const verifyEnvUrl = ( prodBaseUrl, devBaseUrl ) => {
	const isProdEnv = window.location.href.includes( 'https://console.acordofechado.com.br' );
	if ( isProdEnv ) {
		return prodBaseUrl;
	}
  
	return devBaseUrl;
};